import { createApp, watch,  nextTick } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './routes/index.js'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'

import { useSettingsStore } from './stores/settings'
import en from './locales/en.json'
import es from './locales/es.json'
import LanguajeSelector from './components/Global/LanguajeSelector.vue'

const i18n = createI18n({
  legacy: false,
  globalInjection:true,
  locale: localStorage.getItem('language') || 'es',
  fallbackLocale: 'en',
  messages: { en, es }

})

const pinia = createPinia()


loadFonts()

const app = createApp(App)
app.use(router)
app.use(vuetify)
app.use(pinia)
app.use(i18n)
app.component("LanguageSelector", LanguajeSelector);



const settings = useSettingsStore()
settings.initTheme()

watch(() => settings.language, async (lang) => {
  i18n.global.locale.value = lang
   await nextTick()
})

app.mount('#app')

